import { render } from "./newSet.vue?vue&type=template&id=53ed930a&scoped=true&ts=true"
import script from "./newSet.vue?vue&type=script&lang=ts"
export * from "./newSet.vue?vue&type=script&lang=ts"

import "./newSet.vue?vue&type=style&index=0&id=53ed930a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ed930a"]])

export default __exports__